import { useCallback } from 'react';

import { DateTime } from 'luxon';
import { Box, DatePickerInput, Grid, Select, SimpleGrid, TextInput, TimeInput } from 'ui';
import { UseFormReturnType } from 'ui/Form';

import { AddEditTicketFormType } from '../AddTicketForm.type';

type SeasonTicketSalesStartInputsProps = {
  form: UseFormReturnType<AddEditTicketFormType>;
};

const SeasonTicketSalesStartInputs = ({ form }: SeasonTicketSalesStartInputsProps) => {
  const formattedStartTime = form.values.ticket_window_data?.start?.date
    ? DateTime.fromJSDate(form.values.ticket_window_data?.start?.date).toFormat('HH:mm:ss')
    : undefined;

  const handleTimeChange = useCallback(
    (value: string) => {
      const date = form.values.ticket_window_data?.start?.date
        ? DateTime.fromJSDate(form.values.ticket_window_data?.start?.date)
        : DateTime.now();

      const finalDateTime = date.set({
        hour: parseInt(value.split(':')[0]),
        minute: parseInt(value.split(':')[1]),
        second: 0,
        millisecond: 0,
      });
      form.setFieldValue('ticket_window_data.start.date', finalDateTime.toJSDate());
    },
    [form]
  );

  return (
    <SimpleGrid cols={2}>
      <Select
        label="Ticket Sales Start"
        required
        data={[
          { label: 'When Event is Published', value: 'on_publish_date' },
          { label: 'On a Specific Date', value: 'custom_date' },
        ]}
        allowDeselect={false}
        {...form.getInputProps('ticket_window_data.start.type')}
      />
      <Box />
      {form.values.ticket_window_data?.start?.type === 'custom_date' && (
        <>
          <DatePickerInput
            label="Start Date"
            placeholder="Select start date"
            required
            {...form.getInputProps('ticket_window_data.start.date')}
          />
          <Grid>
            <Grid.Col span={6}>
              <TimeInput
                label="Start Time"
                defaultValue={formattedStartTime}
                required
                onChange={(e) => handleTimeChange(e.target.value)}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <TextInput
                label="Timezone"
                value={Intl.DateTimeFormat().resolvedOptions().timeZone}
                readOnly
              />
            </Grid.Col>
          </Grid>
        </>
      )}
    </SimpleGrid>
  );
};

export default SeasonTicketSalesStartInputs;
